(function () {
        var track = document.querySelector('.ingredients-carousel');
        var wrap = document.querySelector('.ingredients-carousel-wrap');
        if (!track || !wrap) return;
        var originals = Array.prototype.slice.call(track.querySelectorAll('.ing-tile'));
        if (originals.length < 2) return;

        originals.forEach(function (el) { el.dataset.ingOriginal = '1'; });
        var prependFrag = document.createDocumentFragment();
        var appendFrag = document.createDocumentFragment();
        originals.forEach(function (el) {
            var a = el.cloneNode(true); a.dataset.ingClone = '1'; delete a.dataset.ingOriginal;
            var b = el.cloneNode(true); b.dataset.ingClone = '1'; delete b.dataset.ingOriginal;
            prependFrag.appendChild(a);
            appendFrag.appendChild(b);
        });
        track.appendChild(appendFrag);
        track.insertBefore(prependFrag, track.firstChild);

        function gapPx() {
            var cs = getComputedStyle(track);
            return parseFloat(cs.columnGap || cs.gap) || 0;
        }
        function tileStep() {
            var first = track.querySelector('[data-ing-original="1"]');
            if (!first) return 0;
            return first.offsetWidth + gapPx();
        }
        function setWidth() {
            var realTiles = track.querySelectorAll('[data-ing-original="1"]');
            if (!realTiles.length) return 0;
            return realTiles.length * tileStep();
        }
        function peekPx() {
            return Math.min(96, Math.round(track.clientWidth * 0.12));
        }

        var initialised = false;
        function anchor() {
            var firstOriginal = track.querySelector('[data-ing-original="1"]');
            if (!firstOriginal) return;
            track.scrollLeft = firstOriginal.offsetLeft - peekPx();
            initialised = true;
        }
        requestAnimationFrame(anchor);
        window.addEventListener('load', anchor);
        window.addEventListener('resize', anchor);

        var ticking = false;
        function rebalance() {
            var w = setWidth();
            if (!w) return;
            var firstOriginal = track.querySelector('[data-ing-original="1"]');
            var realStart = firstOriginal.offsetLeft;
            var sl = track.scrollLeft;
            if (sl < realStart - w * 0.5) track.scrollLeft = sl + w;
            else if (sl > realStart + w * 0.5) track.scrollLeft = sl - w;
        }
        track.addEventListener('scroll', function () {
            if (!initialised || ticking) return;
            ticking = true;
            requestAnimationFrame(function () { ticking = false; rebalance(); });
        }, { passive: true });

        // ---- Arrow buttons: scroll by one tile, smoothly ----
        function step(dir) {
            var s = tileStep();
            if (!s) return;
            track.scrollBy({ left: dir * s, behavior: 'smooth' });
        }
        var prevBtn = wrap.querySelector('.ing-arrow-prev');
        var nextBtn = wrap.querySelector('.ing-arrow-next');
        if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
        if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });

        // ---- Drag / swipe to scroll (with momentum) ----
        var isDown = false, startX = 0, startScroll = 0, moved = 0, pointerId = null;
        var lastX = 0, lastT = 0, velocity = 0, momentumRAF = null;

        function stopMomentum() {
            if (momentumRAF) { cancelAnimationFrame(momentumRAF); momentumRAF = null; }
        }
        function runMomentum() {
            stopMomentum();
            var friction = 0.94; // per frame decay (~60fps)
            function tick() {
                if (Math.abs(velocity) < 0.25) { momentumRAF = null; return; }
                track.scrollLeft += velocity;
                velocity *= friction;
                momentumRAF = requestAnimationFrame(tick);
            }
            momentumRAF = requestAnimationFrame(tick);
        }

        track.addEventListener('pointerdown', function (e) {
            if (e.button !== undefined && e.button !== 0) return;
            stopMomentum();
            isDown = true;
            moved = 0;
            startX = e.clientX;
            lastX = e.clientX;
            lastT = performance.now();
            velocity = 0;
            startScroll = track.scrollLeft;
            pointerId = e.pointerId;
            try { track.setPointerCapture(pointerId); } catch (_) {}
        });
        track.addEventListener('pointermove', function (e) {
            if (!isDown) return;
            var dx = e.clientX - startX;
            if (Math.abs(dx) > 4) {
                track.classList.add('is-dragging');
            }
            moved = Math.max(moved, Math.abs(dx));
            track.scrollLeft = startScroll - dx;
            // Track instantaneous velocity (px per frame, sign matches scrollLeft delta).
            var now = performance.now();
            var dt = Math.max(1, now - lastT);
            // Frame-normalized velocity (~16.67ms per frame).
            var inst = -((e.clientX - lastX) / dt) * 16.67;
            // Smooth a bit so a jittery final sample doesn't dominate.
            velocity = velocity * 0.6 + inst * 0.4;
            lastX = e.clientX;
            lastT = now;
        });
        function endDrag(e) {
            if (!isDown) return;
            isDown = false;
            try { if (pointerId !== null) track.releasePointerCapture(pointerId); } catch (_) {}
            pointerId = null;
            setTimeout(function () { track.classList.remove('is-dragging'); }, 0);
            // Cap and launch momentum if the drag had real velocity.
            if (Math.abs(velocity) > 1.2 && moved > 6) {
                velocity = Math.max(-60, Math.min(60, velocity));
                runMomentum();
            } else {
                velocity = 0;
            }
        }
        track.addEventListener('pointerup', endDrag);
        track.addEventListener('pointercancel', endDrag);
        track.addEventListener('pointerleave', endDrag);
        // Stop momentum if the user grabs again or clicks an arrow.
        if (prevBtn) prevBtn.addEventListener('pointerdown', stopMomentum);
        if (nextBtn) nextBtn.addEventListener('pointerdown', stopMomentum);
        // Suppress click after a drag so accidental clicks on links/buttons don't fire.
        track.addEventListener('click', function (e) {
            if (moved > 6) { e.preventDefault(); e.stopPropagation(); }
        }, true);
        // Prevent native image drag interfering with pointer drag.
        track.querySelectorAll('img').forEach(function (img) { img.setAttribute('draggable', 'false'); });
    })();
;(function(){document.documentElement.classList.add('amie-static-rendered');})();
